import { SurveyResponse } from '@/types'
import { match } from 'ts-pattern'
import massCleanPeakSurveyContent from './surveys/mass-clean-peak'
import { EnrollmentSurveys } from '@/app/components/SurveyObserver/SurveyObserver'

export type EnrollmentSurveyContent = {
  header: string
  rowItems: string[]
}

export default function getEnrollmentSurveyContent(
  surveyResponse: SurveyResponse,
) {
  return match(surveyResponse.survey.type as EnrollmentSurveys)
    .returnType<EnrollmentSurveyContent>()
    .with(EnrollmentSurveys.MassCleanPeak, () =>
      massCleanPeakSurveyContent(surveyResponse),
    )
    .exhaustive()
}
